<template>
  <div class="organizationMain">
    <el-row class="roleManager-title" v-if="isViewTitle">
      <bread-crubm :navMenu="['角色管理']" />
    </el-row>
    <div class="roleManage-box" :style="{height: isViewTitle ? '' : '100%'}">
      <!-- 组件左边区域 -->
      <div class="leftMenu" id="leftMenu">
        <div class="buttonArea">
          <el-button type="primary" size="mini" @click="changeGroupName(0)">新增组</el-button>
          <el-button size="mini" @click="addrole">新增角色</el-button>
          <el-button size="mini" @click="batchAddRole">批量导入</el-button>
        </div>
        <!-- 组列表 -->
        <div class="menuList">
          <VueDraggable v-model="roleGrouplist" chosen-class="chosen" handle=".icon-paixu" force-fallback="true" animation="500" @end="onEnd(0)">
            <transition-group>
                <div v-for="(item, key) in roleGrouplist" 
                    :key="item.roleId"
                    @click="getrolelistEvent(item, key)"
                    :class="{
                              active: newRolePid==item.roleId,
                              admin: item.type == 1 || item.type == 3,
                              item: true
                            }">
                  <i class="iconfont icon-paixu sort-icon"></i>
                  {{item.name}}
                </div>
            </transition-group>
          </VueDraggable>
        </div>
      </div>
      <!-- 组件右边区域 -->
      <div class="rightAppManager">
        <!-- 顶部操作栏 -->
        <el-row class="AppManager-title">
          <el-col :span="24">
            <div class="goBack" @click="$router.replace('/adminMain')" v-if="$route.path.indexOf('admins') !== -1">
              <i class="el-icon-arrow-left"></i>
            </div>
            <!-- 名称 -->
            <!-- <div class="name">{{ roleMsg.name }}</div> -->
            <!-- 搜索组织成员 -->
            <div
              class="mangerBtnArea"
              v-if="roleMsg.type != 1 && roleMsg.type != 3 && roleMsg.type != 10"
            >
              <el-button size="mini"  @click="changeGroupName(1)">编辑当前组</el-button>
              <el-button size="mini"  @click="handleDelList">批量删除角色</el-button>
            </div>
            <div class="search-block">
              <el-input
                placeholder="请输入内容"
                v-model="search"
                @keyup.enter="yesSearch"
                :style="{ '--el-input-bg-color': '#f2f2f2' }"
              >
                <template #prefix>
                  <i class="iconfont icon-sousuo"></i>
                </template>
              </el-input>
              <el-button size="mini" type="primary" @click="yesSearch"
                >搜索</el-button
              >
              <el-button size="mini" @click="emptySearch">清空</el-button>
            </div>
          </el-col>
        </el-row>
        <!-- 底部表数据 -->
        <div
          class="AppManager-list"
          v-loading="loading"
          element-loading-text="数据加载中"
        >
          <ul>
            <li class="table-head">
              <span><el-checkbox v-model="checkAllVal" @change="checkAll" ></el-checkbox></span>
              <span>角色名字</span>
              <span>所在组</span>
              <span>是否激活</span>
              <span>操作</span>
            </li>
            <VueDraggable v-model="getrolelists" handle=".icon-paixu" force-fallback="true" animation="500" @end="onEnd(1)">
              <transition-group>
                <li class="table-tr" 
                    v-for="(item, index) in getrolelists" 
                    :style="{background: index%2==0 ? '#fff' : 'rga(248, 249, 251)'}" 
                    :key="item.roleId">
                  <div>
                    <el-checkbox v-model="item.checked" @change="val=>{checkNode(val, item)}"></el-checkbox>
                  </div>
                  <div>{{ item.name }}</div>
                  <div>{{ item.pname }}</div>
                  <div>
                    <span v-if="item.status == 0" class="status unstatus">未激活</span>
                    <span v-else class="status">激活</span>
                  </div>
                  <div>
                    <template v-if="item.type == 0 || item.type == -1">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="权限设置"
                        placement="bottom-end"
                      >
                        <i class="icon iconfont icon-quanxianpeizhi" @click="handleAuthorization(index, item)"></i>
                      </el-tooltip>
                      <span class="todo-center"></span>
                    </template>
                    <template v-if="item.type == 0">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="编辑"
                        placement="bottom-end"
                      >
                        <i class="icon WSiconfont WSicon-a-EditSquare1" @click="handleEdit(index, item)"></i>
                      </el-tooltip>
                      <span class="todo-center"></span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="删除"
                        placement="bottom-end"
                      >
                        <i class="icon WSiconfont WSicon-shanchu" @click="handleDelete(index, item)"></i>
                      </el-tooltip>
                      <span class="todo-center"></span>
                    </template>
                    <i class="iconfont icon-paixu sort-icon"></i>
                  </div>
                </li>
              </transition-group>
            </VueDraggable>
          </ul>
        </div>
      </div>
    </div>
    <roleAuthorization
      ref="roleAuthorizationGo"
      @roleAuthorizationBack="roleAuthorizationBack"
      v-model:show="roleAuthorizationShow"
    ></roleAuthorization>
    <!-- 批量导入 -->
    <org-import 
      v-model:isView="popupBatchAddRole"
      type="role"
      @importSuccess="importSuccess"
      :isShowTitle="false"></org-import>
    <!-- 添加(修改)角色 -->
    <dialogPack v-model:isView="newRoleVisible" :title="roleTitle" @close="newRoleReset('newRoleForm')">
      <template v-slot:body>
        <el-form
          :model="newRoleForm"
          ref="newRoleForm"
          label-width="80px"
          class="newgroupBody"
        >
          <el-form-item
            label="角色名"
            prop="name"
            :rules="[
              { required: true, message: '角色名不能为空', trigger: 'blur' },
            ]"
          >
            <el-input v-model="newRoleForm.name"></el-input>
          </el-form-item>
          <el-form-item
            label="分组到"
            prop="pid"
            :rules="{
              required: true,
              message: '角色分组不能为空',
              trigger: 'false',
            }"
          >
            <el-select
              v-model="newRoleForm.pid"
              placeholder="请选择分组"
              style="width: 100%"
            >
              <el-option
                :label="item.name"
                :value="item.roleId"
                v-for="item in roleGrouplist"
                :key="item.id"
                :disabled="item.type == 1 || item.type == 3 || item.type == 10"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="激活" prop="status">
            <el-radio-group v-model="newRoleForm.status">
              <el-radio :value="1">激活</el-radio>
              <el-radio :value="0">不激活</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="bottom-button">
          <el-button @click="newRoleReset('newRoleForm')">取 消</el-button>
          <el-button type="primary" @click="newRoleSubmit('newRoleForm')">保 存</el-button>
        </div>
      </template>
    </dialogPack>

    <!-- 添加(修改)角色组 -->
    <dialogPack v-model:isView="newgroupVisible" :title="groupTitle" @close="newgroupReset('newgroupForm')">
      <template v-slot:body>
        <el-form
          :model="newgroupForm"
          ref="newgroupForm"
          label-width="60px"
          class="newgroupBody"
        >
          <el-form-item
            label="组名"
            prop="name"
            :rules="[
              { required: true, message: '组名不能为空', trigger: 'blur' },
            ]"
          >
            <el-input v-model="newgroupForm.name"></el-input>
          </el-form-item>
        </el-form>
        <div class="bottom-button">
          <el-button
            @click="newgroupDel('newgroupForm')"
            v-if="newgroupForm.roleId"
            >删 除</el-button
          >
          <el-button @click="newgroupReset('newgroupForm')">取 消</el-button>
          <el-button type="primary" @click="newgroupSubmit('newgroupForm')"
            >确 定</el-button
          >
        </div>
      </template>
    </dialogPack>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { axiosBase } from "../../../api/api";
import roleAuthorization from './roleAuthorization'

export default {
  name: 'organizationMain',
  data () {
    return {
      active: 0,
      rowIndex: 0,
      loading: true,
      roleGrouplist: [],//角色组
      getrolelists: [],//用户信息
      roleAuthorizationShow: false,//权限组建显示
      roleMsg: { name: '' },
      //新建分组
      newgroupVisible: false,
      groupTitle: '添加组',

      newgroupForm: { name: '', orders: '', status: 1, pid: 0 },
      //新建角色
      roleTitle: '新增角色',
      newRoleVisible: false,
      newRoleForm: {
        name: '',
        pid: '',
        orders: 0
      },
      newRolePid: null,//新增角色或者修改角色临时使用的pid
      multipleSelection: [],
      search: '', //搜索
      isZt: false, // 中台打开使用
      isSpace: false, // 是否从空间进入
      popupBatchAddRole: false, // 是否打开批量导入角色的弹窗
      checkAllVal: false
    }
  },
  created() {
    const path = this.$route.path
    if (path && path === '/admins/organization/organizationRoles') this.isZt = true;
    if (path && path === '/spaceMain/roule') this.isSpace = true;
  },
  components: {
    roleAuthorization,
    BreadCrubm: defineAsyncComponent(() => import('./common/breadCrubm.vue')),
    dialogPack: defineAsyncComponent(() => import('./common/dialogPack.vue')),
    orgImport: defineAsyncComponent(() => import('./common/orgImport.vue')),
  },
  computed: {
    isViewTitle() {
      return this.$route.path !== '/organizationRole' || this.isAppenTitle
    },
  },
  props: {
    isAppenTitle: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    // 角色选择全部
    checkAll(val) {
      if(val) {
        this.getrolelists.forEach(e=> {
          this.multipleSelection.push(e.roleId)
          e.checked = true
        })
       } else {
        this.multipleSelection = []
        this.getrolelists.forEach(e=> {
          e.checked = false
        })
      }
    },
    // 选择角色
    checkNode(val, item) {
      if(val) {
        this.multipleSelection.push(item.roleId)
       } else {
        const index = this.multipleSelection.indexOf(item.roleId)
        this.multipleSelection.splice(index, 1)
      }
      this.checkAllVal = this.getrolelists.length === this.multipleSelection.length ? true : false
    },
    // 拖拉排序
    async onEnd(val) {
      // 0是组 1是角色
      const obj = []
      const arrName = val === 0 ? 'roleGrouplist' : 'getrolelists'
      const len = this[arrName].length
      this[arrName].forEach((e, i) => {
        obj.push({
          roleId: e.roleId,
          orders: len - i
        })
      })
      await axiosBase({parameters:JSON.stringify(obj)}, 'api/batchsetroleorder')
    },
    // 导入成功
    importSuccess() {
      this.getroleGrouplist()
      this.popupBatchAddRole = false
    },
    // 批量导入
    batchAddRole() {
      this.popupBatchAddRole = true
    },
    yesSearch () {
      console.log('搜索', this.search);
      if (this.search == '') {
        this.$message({ type: "info", message: "请输入搜索内容!" });
        return false;
      }
      this.getrolelistEvent({ roleId: -1 }, -1, this.search);
    },
    emptySearch () {
      this.search = '';
      this.getroleGrouplist();
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    handleDelete (index, row) {
      // if(row.usernum>0){
      //   this.$message({type: "info", message: "该角色下包含了用户，请删除用户后再删除该角色!"});
      //   return
      // }
      this.$confirm('您确定要删除该角色?', '提示', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        const obj = { roleId: row.roleId };
        // 从空间进入，需要传空间id
        if(this.isSpace){
          let spaceId = localStorage.getItem('spaceid');
          obj.spaceid = spaceId;
        }
        axiosBase(obj, "/api/deleterole").then(res => {
          if (res.code == 0) {
            this.getrolelists.splice(index, 1);
            this.$message({ type: "success", message: "删除成功!" });
          } else {
            this.$message({ type: "info", message: "删除失败!" });
          }
          this.loading = false
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDelList () {
      if (this.multipleSelection.length > 0) {
        this.$confirm('确定要删除选中的' + this.multipleSelection.length + '个角色?', '提示', {
          confirmButtonClass: 'el-button--yeprimary',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          const obj = { roleId: this.multipleSelection };
          // 从空间进入，需要传空间id
          if(this.isSpace){
            let spaceId = localStorage.getItem('spaceid');
            obj.spaceid = spaceId;
          }
          axiosBase(obj, "/api/deleterole").then(res => {
            this.loading = false
            if (res.code == 0) {
              this.getrolelistEvent({ roleId: this.newRolePid }, this.active)
              this.$message({ type: "success", message: "删除成功!" });
            } else {
              this.$message({ type: "info", message: "删除失败!" });
            }
          });
        }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      } else {
        this.$message({ type: "info", message: "请选择要删除的角色!" });
        return
      }
      
    },
    getroleGrouplist () {//获取角色分组列表      
      const obj = { pid: 0, curpage: 0, pagesize: 0 };
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = localStorage.getItem('spaceid');
        obj.spaceid = spaceId;
      }
      axiosBase(obj, "/api/getrolelist").then(res => {
        if (res.data.length > 0) {
          this.roleGrouplist = res.data
          this.getrolelistEvent(res.data[0], 0)
        } else {
          this.loading = false
        }
      });
    },
    getrolelistEvent (item, key, name) {//获取角色
      this.loading = true
      this.multipleSelection = []
      this.checkAllVal = false
      this.newRolePid = item.roleId;
      // this.newRoleForm.pid = item.roleId;
      let param = {
        pid: item.roleId,
        curpage: 0,
        pagesize: 0
      }
      if (name) {
        param.name = name;
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = localStorage.getItem('spaceid');
        param.spaceid = spaceId;
      }
      axiosBase(param, "/api/getrolelist").then(res => {
        if (item.name) {
          this.roleMsg = { roleId: item.roleId, name: item.name, type: item.type, status: item.status, orders: item.orders }
        } else {
          this.roleMsg.roleId = item.roleId
        }
        this.active = key
        this.getrolelists = res.data.map(e=> {
            e.checked = false
            return e
        })
        this.loading = false
      });
    },
    changeGroupName (key) {//修改分组名称
      if (key == 0) {//新建
        this.groupTitle = '新增组'
        this.newgroupForm = { name: '', orders: '', status: 1, pid: 0 };
        // 从空间进入，需要传空间id
        if(this.isSpace){
          let spaceId = localStorage.getItem('spaceid');
          this.newgroupForm.spaceid = spaceId;
        }
      } else {//修改
        this.groupTitle = '修改组'
        this.newgroupForm = JSON.parse(JSON.stringify(this.roleMsg))
      }
      this.newgroupVisible = true;
    },
    newgroupSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.newgroupVisible = true;
          if (this.newgroupForm.orders && this.newgroupForm.orders != '') {
            this.newgroupForm.orders = parseInt(this.newgroupForm.orders)
          }
          // 从空间进入，需要传空间id
          if(this.isSpace){
            let spaceId = localStorage.getItem('spaceid');
            this.newgroupForm.spaceid = spaceId;
          }
          if (this.newgroupForm.roleId) {//修改
            axiosBase(this.newgroupForm, "/api/updaterole").then(res => {
              if (res.code == 0) {
                this.getroleGrouplist();
                this.$message({ type: "success", message: "修改成功!" });
              } else {
                this.$message({ type: "info", message: res.msg + '!' });
              }
            });
          } else {//新增
            axiosBase(this.newgroupForm, "/api/addrole").then(res => {
              if (res.code == 0) {
                this.getroleGrouplist();
                this.$message({ type: "success", message: "新增成功!" });
              } else {
                this.$message({ type: "info", message: res.msg + '!' });
              }
            });
          }
          this.newgroupVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    newgroupReset (formName) {
      this.$refs[formName].resetFields();
      this.newgroupVisible = false;
    },
    addrole () {//新增角色
      this.roleTitle = '新增角色'
      this.newRoleForm.status = 1
      this.newRoleForm.name = ''
      if (this.newRoleForm.roleId) delete this.newRoleForm.roleId;
      // this.newRoleForm.roleId = null;
      this.newRoleVisible = true
    },
    handleAuthorization (index, row) {//权限设置
      this.rowIndex = index;
      this.roleAuthorizationShow = true
      console.log(this.roleAuthorizationShow );
      this.$refs.roleAuthorizationGo.roleAuthorizationMethod(row);
    },
    roleAuthorizationBack (item) {//回调
      this.getrolelists[this.rowIndex].pers = JSON.stringify(item)
      this.roleAuthorizationShow = false
    },
    handleEdit (index, row) {//修改角色
      this.newRoleForm = { name: row.name, orders: row.orders, pid: row.pid, roleId: row.roleId, status: row.status, permissionId: row.permissionId }
      this.newRoleVisible = true;
      this.roleTitle = '编辑角色'
    },
    newRoleSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.newRoleForm.orders && this.newRoleForm.orders != '') {
            this.newRoleForm.orders = parseInt(this.newRoleForm.orders)
          }
          this.newRoleVisible = true;
          if (this.newRoleForm.roleId) {//修改
            this.loading = true
            axiosBase(this.newRoleForm, "/api/updaterole").then(res => {
              this.loading = false
              if (res.code == 0) {
                this.getrolelistEvent({ roleId: this.newRolePid }, this.active)
                this.$message({ type: "success", message: "修改成功!" });
              } else {
                this.$message({ type: "info", message: res.msg + "!" });
              }
            });
          } else {//新增
            this.loading = true;
            // 从空间进入，需要传空间id
            if(this.isSpace){
              let spaceId = localStorage.getItem('spaceid');
              this.newRoleForm.spaceid = spaceId;
            }
            axiosBase(this.newRoleForm, "/api/addrole").then(res => {
              this.loading = false
              if (res.code == 0) {
                this.getrolelistEvent({ roleId: this.newRolePid }, this.active)
                this.$message({ type: "success", message: "新增成功!" });
              } else {
                this.$message({ type: "info", message: res.msg + "!" });
              }
            });
          }
          this.newRoleVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    newgroupDel () {
      this.$confirm('确定要删除选中部门?', '提示', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const obj = { roleId: this.newgroupForm.roleId };
        // 从空间进入，需要传空间id
        if(this.isSpace){
          let spaceId = localStorage.getItem('spaceid');
          obj.spaceid = spaceId;
        }
        axiosBase(obj, "/api/deleterole").then(res => {
          if (res.code == 0) {
            this.getroleGrouplist();
            this.$message({ type: "success", message: "分组删除成功!" });
            this.newgroupVisible = false;
          } else {
            this.$message({ type: "info", message: "分组删除失败!" });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    newRoleReset (formName) {
      this.$refs[formName].resetFields();
      this.newRoleVisible = false;
    },
  },
  mounted () {
    this.getroleGrouplist();
    this.$emit('childKey', 1);
    //- 设置首页头部切换状态
    this.$store.commit('changeSelect', 4);


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./css/common.scss";

.organizationMain {
  width: 100%;
  height: 100%;
  .roleManager-title{
    padding: 11px 7px 21px 7px;
  }
  .roleManage-box {
    height: calc(100% - 46px);
    display: flex;
  }
  .leftMenu {
    width: 330px;
    height: 100%;
    background: #ffffff;
    overflow: hidden;
    padding-top: 24px;
    box-sizing: border-box;
    border-right: 1px solid rgba(240, 240, 240, 1);     
    .buttonArea {
      padding: 0 24px;
      display: flex;
      justify-content: space-around;
      
    }
    .menuList {
      height: calc(100vh - 220px);
      padding-bottom: 20px;
      overflow: hidden;
      overflow-y: auto;
      width: 100%;
      margin-top: 16px;
      color: rgba(118, 134, 148, 1);
      font-weight: 400;
      
      .item {
        height: 40px;
        border-radius: 6px;
        line-height: 40px;
        position: relative;
        color: #666;
        padding-left: 24px;
        cursor: pointer;
        user-select: none;
        &:hover {
          background: rgba(247, 249, 250, 1);
          font-weight: 500;
          color:rgba(56, 162, 251, 1);
        }
        
      }
      .active {
        background: rgba(247, 249, 250, 1);
        font-weight: 500;
        color:rgba(56, 162, 251, 1);
      }
      .chosen {
        border: solid 1px #3089dc !important;
      }
    }
  }
  .rightAppManager {
    flex: 1;
    background-color: #fff;
    padding: 24px 16px 0 16px;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    .AppManager-title {
      overflow: hidden;
      padding-bottom: 16px;
      ::v-deep .el-col {
        display: flex;
        justify-content: space-between;
      }
      .goBack{
        display: inline-block;
        line-height: 36px;
        font-size: 20px;
        cursor: pointer;
      }
      .search-block {
        margin-left: auto;
        height: 36px;
        line-height: 36px;
        width: 50%;
        text-align: right;
        float: right;
        ::v-deep .el-input {
          width: 55%;
          margin-right: 6px;
          .el-input__inner {
            width: 100%;
            border-radius: 6px;
            border: none;
          }
        }
      }
    }
    .AppManager-list {
      height: calc(100% - 86px);
      color: #33393E;
      li {
        display: flex;
      }
      .table-head, .table-tr {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        span, div {
          text-align: center;
        }
        span:nth-child(1), div:nth-child(1) {
          width: 50px;
        }
        span:nth-child(2), div:nth-child(2) {
          flex: 1;
        }
        span:nth-child(3), div:nth-child(3) {
          width: 180px
        }
        span:nth-child(4), div:nth-child(4) {
          width: 120px;
        }
        span:nth-child(5), div:nth-child(5) {
          width: 220px;
          .todo-center {
            display: inline-block;
            width: 1px;
            background: #ebe8e1;
            margin-bottom: 0;
            height: 10px;
          }
        }
      }
      .table-head {
        background-color: #EAEDF2;
      }
      .table-tr {
        border-bottom: 1px solid rgba(237, 240, 245, 1);       
      }
      .group-label {
        display: inline-block;
        width: 93px;
        height: 24px;
        border-radius: 4px;
        background: rgba(255, 139, 10, 0.1);
        line-height: 24px;
        text-align: center;
        padding: 2px 16px 2px 16px;
        color: rgba(255, 139, 10, 1);
      }
      .status {
        display: inline-block;
        border-radius: 16px;
        background: rgba(6, 212, 125, 0.1);
        padding: 2px 16px 2px 16px;
        width: 68px;
        height: 24px;
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        color: rgba(6, 212, 125, 1);
        text-align: center;
      }
      .unstatus {
        background: rgba(225, 230, 235, 0.5);
        color: rgba(173, 176, 178, 1);
      }
    }
  }
}
/*滚动条样式 */ 
::v-deep .menuList::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  display: none;
}
::v-deep .menuList::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 2px;
}
::v-deep .menuList::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
::v-deep.el-form {
  .el-form-item {
    margin-bottom: 16px;
    .el-form-item__label {
      padding-right: 8px;
      text-align: right;
      font-family: $text-family;
      color: $color-default;
    }
    .el-input {
      height: 32px;
      line-height: 32px;
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
  }
}
// 添加组的按钮
.bottom-button{
  width: 100%;
  text-align: right;
  ::v-deep .el-button {
    .el-button--default {
      span {
        color: #ADB0B2;
      }
    }
  }
}
.icon {
  cursor: pointer;
}
.icon-paixu {
  cursor: move;
}
.icon-quanxianpeizhi {
  color: #06d47d;
}
.WSicon-a-EditSquare1 {
  color: rgba(56, 162, 251, 1);
}
.WSicon-shanchu {
  color: rgba(253, 111, 92, 1);
}
// 表格样式
.el-table {
  ::v-deep th, td {
    padding: 8px 0 !important;
  }
}
</style>
